import { blockScroll } from '@uefadigital/panenka';
import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { memo, useEffect, useId } from 'react';
import ReactModal from 'react-modal';

import ErrorBoundary from '../ErrorBoundary';

import { SimpleHeader } from './SimpleHeader';

import type { PkTheme } from '@shared-types/common.types';
import { competitionName as compName, competitionUrl as compUrl, competitionCode } from '@utilities/WindowContext';

// import '../../../../css/modules/common/sponsored-header.source.scss';
import * as styles from './styles.module.scss';

const Modal = ({
  children,
  showModal,
  handleCloseModal,
  hideButtons,
  hideCompetitionLink = false,
  showHeader,
  withScroll = true,
  headerTitle,
  className,
  overlayClassName,
  competitionName = compName,
  competitionUrl = compUrl,
  sponsorName,
  headerTheme,
  bodyTheme,
}: {
  children: ReactNode;
  showModal: boolean;
  handleCloseModal?: () => unknown;
  hideButtons?: boolean;
  hideCompetitionLink?: boolean;
  showHeader?: boolean;
  withScroll?: boolean;
  headerTitle?: string;
  className?: string;
  overlayClassName?: string;
  competitionName?: string;
  competitionUrl?: string;
  sponsorName?: string;
  headerTheme?: PkTheme;
  bodyTheme?: PkTheme;
}) => {
  const modalId = useId();
  useEffect(() => {
    const key = `react-modal-${modalId}`;
    blockScroll(showModal, key);

    return () => {
      blockScroll(false, key);
    };
  }, [modalId, showModal]);

  return (
    <ReactModal
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      shouldCloseOnOverlayClick
      overlayClassName={clsx(styles.overlay, overlayClassName)}
      className={clsx(
        styles.modal,
        showHeader && withScroll && styles.withScroll,
        className,
        bodyTheme && `pk-theme--${bodyTheme}`,
      )}
      ariaHideApp={false}
      pk-competition={competitionCode}
    >
      {!hideButtons && (
        <PkButton className='close-btn' appearance='icon' onPkClick={handleCloseModal}>
          <PkIcon name='navigation-close' />
        </PkButton>
      )}
      {showHeader && (
        <SimpleHeader
          title={headerTitle}
          handleCloseModal={handleCloseModal}
          competitionName={competitionName}
          competitionUrl={competitionUrl}
          sponsorName={sponsorName}
          theme={headerTheme}
          hideCompetitionLink={hideCompetitionLink}
        />
      )}
      <ErrorBoundary>{children}</ErrorBoundary>
    </ReactModal>
  );
};

export default memo(Modal);
